import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { KMCDepartmentLeftManu } from "../components/KMCDepartmentLeftManu";
import { KMCDepartmentList, stickyHeaderStyle } from "../utils/constants";
import { useState } from "react";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";

const KMC_Department = () => {
  const { t } = useTranslation();
  const [isMoreBtnClick, setIsMoreBtnClick] = useState(false);
  return (
    <>
      {/* Slider */}
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> {t("KMC_DEPARTMENTS")}</h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <KMCDepartmentLeftManu />
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass"> {t("KMC_DEPARTMENTS")}</h3>
                  </div>
                  <div className="col-lg-12 about-head1">
                    <p className="fontSizeClass">{t("KMC_DEPARTMENTS_text")}</p>
                    <div class="dropdown my-2">
                      <div className="more-but">
                        <button
                          type="button"
                          className="btn btn-primary mb-2"
                          data-toggle="collapse"
                          data-target="#demo6"
                          onClick={() => setIsMoreBtnClick(!isMoreBtnClick)}
                        >
                          {t(isMoreBtnClick ? "Less" : "More")}
                          <i
                            className={`bi bi-chevron-${
                              isMoreBtnClick ? "up" : "down"
                            }`}
                            style={{ marginLeft: "10px" }}
                          />
                        </button>
                        <div id="demo6" className="collapse">
                          <p className="fontSizeClass">
                            {t("KMC_DEPARTMENTS_text1")}
                          </p>
                        </div>
                        <div className="mt-3">
                          KMC has the following departments to provide various
                          services to the citizens of Kolkata..
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mayor-table2 mayor-table depart my-2">
                    <table className="table mayor-table table-bordered kmc-department">
                      <thead>
                        <tr className="table-warning table-bor-2">
                          <th className="bd-wid" scope="col" style={stickyHeaderStyle}>
                            {t("Sl.No")}.
                          </th>
                          <th scope="col" style={stickyHeaderStyle}> {t("Department")} </th>
                          <th scope="col" style={stickyHeaderStyle}> {t("Key Activities")} </th>
                        </tr>
                      </thead>
                      <tbody>
                        {KMCDepartmentList.map((item, index) => (
                          <tr key={index}>
                            <td> {index + 1} </td>
                            <td>
                              {item.to.startsWith("http") ? (
                                <a
                                  href={item.to}
                                  className="nav-link fontSizeClass"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {t(item.department)}
                                </a>
                              ) : item.isClickable ? (
                                <Link
                                  className="nav-link fontSizeClass"
                                  to={item.to}
                                >
                                  {t(item.department)}
                                </Link>
                              ) : (
                                <span className="nav-link fontSizeClass">
                                  {t(item.department)}
                                </span>
                              )}
                            </td>
                            <td>{
                           item.keyActivities? t(item.keyActivities)
                          :<DownloadFileByFileStoreId fileStoreId={item.fileStoreId} label={item.label} classAdd={false}/>
                          }</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default KMC_Department;
